import { loadUiSetting, saveUiSetting } from '@/lib/ui-settings'
import type { ListCalculationsParams } from '../types/calculation.types'

/**
 * AP-37 9. — was der Navigationsrahmen im Kopf sich merkt (Muster AP-35
 * Nachtrag 5): **zuletzt geöffnet** serverseitig (UI-Einstellung), die
 * **Listenansicht** (Filter, Sortierung) lokal als Arbeitskontext; nach ihr
 * richtet sich das Blättern.
 */
export interface RecentCalculation {
  id: string
  label: string
  name: string
}

const RECENT_KEY = 'recent_calculations'
const RECENT_MAX = 10

export function loadRecentCalculations(): RecentCalculation[] {
  const roh = loadUiSetting<unknown>(RECENT_KEY, [])
  return Array.isArray(roh) ? roh.filter((p): p is RecentCalculation => !!p && typeof (p as RecentCalculation).id === 'string') : []
}

export function rememberRecentCalculation(k: RecentCalculation): RecentCalculation[] {
  const alt = loadRecentCalculations()
  if (alt[0]?.id === k.id && alt[0].label === k.label && alt[0].name === k.name) return alt
  const neu = [k, ...alt.filter((x) => x.id !== k.id)].slice(0, RECENT_MAX)
  saveUiSetting(RECENT_KEY, neu)
  return neu
}

const LIST_CONTEXT_PREFIX = 'symphenia.ui.calculations.listcontext'

export type ListContext = Omit<ListCalculationsParams, 'page' | 'limit'>

export function rememberListContext(userId: string | undefined, ctx: ListContext): void {
  try {
    localStorage.setItem(`${LIST_CONTEXT_PREFIX}.${userId ?? 'anon'}`, JSON.stringify(ctx))
  } catch {
    // ignorieren — ohne Merker blättert der Kopf nach Nummer
  }
}

export function loadListContext(userId: string | undefined): ListContext {
  try {
    const roh = localStorage.getItem(`${LIST_CONTEXT_PREFIX}.${userId ?? 'anon'}`)
    return roh ? (JSON.parse(roh) as ListContext) : {}
  } catch {
    return {}
  }
}
